<h2 i18n="@@titleDashboard">Dashboard</h2>

@if (chargersLoaded) {
    <div class="card-container">
    <mat-card class="mat-elevation-z5 dashboard-card">
        <mat-card-header>
            <mat-card-title>🟢 <span i18n="@@ChargersOnline">Chargers Online</span></mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <p>{{ chargersOnline }} / {{ chargersCount }}</p>
        </mat-card-content>
    </mat-card>

    <mat-card class="mat-elevation-z5 dashboard-card">
        <mat-card-header>
            <mat-card-title>🚘 <span i18n="@@ChargersVehicleConnected">Chargers Vehicle Connected</span></mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <p>{{ chargersVehicleConnected }} / {{ chargersCount }}</p>
        </mat-card-content>
    </mat-card>

    <mat-card class="mat-elevation-z5 dashboard-card">
        <mat-card-header>
            <mat-card-title>🔌 <span i18n="@@TotalPower">Total Power</span> [kW]</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <p>{{ (chargersPower / 1000) | number:'1.1-1' }} ({{ chargersCharging }})</p>
        </mat-card-content>
    </mat-card>

    <mat-card class="mat-elevation-z5 dashboard-card">
        <mat-card-header>
            <mat-card-title>⚡️ <span i18n="@@FirmwareUpdate">Firmware Update</span></mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <p>{{ chargersUpdate }} / {{ chargersCount }}</p>
        </mat-card-content>
    </mat-card>

    </div>
}
@else {
    <mat-spinner />
}
